// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__16jLn","label":"Category_label__3wkUj","content":"Category_content__2sVgv","header":"Category_header__mj-0g","location":"Category_location__3tOhm"};